import CheckBoxField from '../../../../../../CommonComponents/CheckboxField';
import ColorPicker from '../../../../../../CommonComponents/ColorPicker';
import ImageUploader from './ImageUploader';
 
  const FormComp = (props) => {
    const { heading, placeholder, type, name, value, onColorChange, onTextFieldChange, uploadImage, logoImgUploaded, bgImgUploaded, error } = props; 

    return (
      <>
        {type != 6 ? <div className={`form-group mb-3 ${[3, 4].includes(type) ? 'd-flex justify-content-between align-items-center' : ''}`}>
          <label className='font-weight-bolder'>{heading}</label>
          {type == 1 ? <input className='border rounded form-control' type='text' value={value} name={name} placeholder={placeholder} onChange={onTextFieldChange} /> :
            type == 2 ? <textarea className='border rounded d-flex form-control' rows="2" cols="10" value={value} name={name} placeholder={placeholder} onChange={onTextFieldChange}></textarea> :
              type == 3 ? <ColorPicker onUpdateColor={(e) => onColorChange(e)} initialValue={value} /> :
                type == 4 ? <div class="toggleOnBut float-end">
                  <span class="switch">
                    <label>
                      <CheckBoxField isChecked={value} onChangeHandler={(event) => onTextFieldChange({...event, target: {name, value: !value}})} name={name} id={'action-toggle'} text={0} />
                    </label>
                  </span>
                </div> : type == 5 ? <CheckBoxField isChecked={value} onChangeHandler={(event) => onTextFieldChange({...event, target: {name, value: !value}})} name={name} id={'moderation-toggle'} /> : null
          }
          { [1, 2].includes(type) && error? <span class="help-block help-block-error">{error}</span>: null}
        </div> : <ImageUploader heading={heading} name={name} image={value} uploadImg={uploadImage} isUploaded={name == "logoImg" ? logoImgUploaded : bgImgUploaded} />
        }
      </>
    )
  } 

export default FormComp;
